import type { ComponentType } from "react";
import InfoDisplayGridComponent from "./InfoDisplayGrid.jsx";

const InfoDisplayGrid = InfoDisplayGridComponent as ComponentType<any>;
export default InfoDisplayGrid;
